import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"; // Import Firebase Authentication functions
import { useCart } from "contexts/CartContext";
import Logo from "../Logo";
import * as S from "./styles";
import { quantityCartTotal } from "functions";

export default function Header() {
  const { cart } = useCart();
  const quantity__cart = quantityCartTotal(cart);

  // Initialize Firebase Authentication
  const auth = getAuth();

  // Define a state variable to track if the user is signed in
  const [isSignedIn, setIsSignedIn] = useState(false);

  // Function to handle the sign-out action
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      // User is signed out
      setIsSignedIn(false);
      console.log("User signed out successfully!");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Monitor user login state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        setIsSignedIn(true);
      } else {
        // User is signed out
        setIsSignedIn(false);
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, [auth]);

  return (
    <S.StyledHeader>
      <Link to={"/"}>
        <Logo />
      </Link>
      <div style={{ flex: 0.9 }}></div>
      <Link to={"/profile"}>
        <S.ProfileIcon>
          <S.ProfileHeader
            aria-label="ícone de perfil"
            className="fa-solid fa-user"
          >
            {/* Conditionally render "Log In" or "Log Out" button */}
            {isSignedIn ? (
              <S.StyledButton onClick={handleSignOut}>Log Out</S.StyledButton>
            ) : (
              <Link to="/login">
                <S.StyledButton>Log In</S.StyledButton>
              </Link>
            )}
          </S.ProfileHeader>
          
        </S.ProfileIcon>
      </Link>
      <Link to={"/cart"}>
        <S.ContainerIcon>
          <S.IconHeader
            aria-label="ícone sacola de compras"
            className="fa-solid fa-bag-shopping"
          ></S.IconHeader>
          <S.QuantityCart quantity={quantity__cart}>
            {quantity__cart}
          </S.QuantityCart>
        </S.ContainerIcon>
      </Link>
    </S.StyledHeader>
  );
}
